export default {
  NEW_MSG: "@ws-native/NEW_MSG",
  ERROR: "@ws-native/ERROR"
};
